import { NgClass } from "@angular/common";
import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Firestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { NotificationManagerService } from "src/app/services/notification-manager.service";
declare let document;
const setLimit = 20; // set limit to multiply by text length
const blinkCaretTime = 1000;
let typingTime;
@Component({
  selector: "app-narrator-tips",
  templateUrl: "./narrator-tips.component.html",
  styleUrls: ["./narrator-tips.component.scss"],
  standalone: true,
  imports: [NgClass, TranslatePipe],
})
export class NarratorTipsComponent implements OnInit, OnDestroy {
  @ViewChild("narratorContent", { static: false })
  protected isTipDiscountVoucherStore: boolean;
  protected isTipJackpotTrigger: boolean;
  public narratorTipContent: ElementRef;
  private destroy$ = new Subject<void>();
  public closeIconShow: boolean;
  public showText: boolean;
  public narratorTipData: Data;
  public narratorShow: boolean;
  public selectedLanguage: string;
  public languageCode: string;
  public narratorIndex: number;
  public nextButton: boolean;
  public cardImage: boolean;
  public displayTypewriterText: string;
  public total_length: number;
  public setTimer: number;
  public setTimer2: number;
  public displayAvatar: boolean;
  public setTimer3: number;
  public userId: string;
  private profileNickname = "";
  private jackpotTriggerTipViewTracked = false;
  private isDestroyed = false;
  private jackpotTipViewTimeoutId: ReturnType<typeof setTimeout> | null = null;
  /** Captured while the tip is open (before any CTA navigation mutates router.url). */
  private jackpotTriggerEntryPoint: "cancellation_flow" | "other" = "other";

  /** True when the jackpot-trigger "Setup now" CTA replaces the close icon. */
  get showJackpotTriggerCta(): boolean {
    return this.isTipJackpotTrigger && this.displayAvatar && !this.nextButton;
  }

  /** Close icon is never shown for jackpot-trigger; that variant uses Setup now / next instead. */
  get showCloseIcon(): boolean {
    if (this.nextButton || this.isTipJackpotTrigger) {
      return false;
    }
    return this.closeIconShow;
  }

  constructor(
    private firestore: Firestore,
    private angularFireStore: AngularFirestore,
    private authService: AuthService,
    public translate: TranslateService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<NarratorTipsComponent>,
    private el: ElementRef, private renderer: Renderer2,
    private router: Router,
    private notificationManagerService: NotificationManagerService,
    private mixPanelService: MixpanelService,
    private gtmSegment: GTMSegmentService,
    @Inject(MAT_DIALOG_DATA) public narratorData
  ) {
    this.isTipDiscountVoucherStore = false;
    this.isTipJackpotTrigger = this.narratorData?.narrator_id?.trim() === "tip_jackpot_trigger";
    if (this.isTipJackpotTrigger) {
      this.jackpotTriggerEntryPoint = this.resolveJackpotTriggerEntryPoint(this.router.url);
    }
    this.router;
    this.narratorShow = true;
    this.closeIconShow = false;
    this.showText = false;
    this.selectedLanguage = "en";
    this.languageCode = "en";
    this.narratorIndex = 0;
    this.cardImage = false;
    this.displayAvatar = false;
    const setValue = 100; // set timer value
    this.setTimer3 = setValue;
    this.setTimer = 4000;
    this.setTimer2 = 2000;

    //This is used to check if the user is logged in or not and to set the language code
    this.authService?.userDetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      (user: Data) => {
        this.languageCode = user?.language_code ? user?.language_code : "en";
        this.profileNickname = user?.name ?? "";
        translate.use(this.languageCode ? this.languageCode : "en");
      },
        () => { }
    );
  }

  async ngOnInit() {
    await this.authService.getUid("NarratorTipsComponent").then((uid) => {
      this.userId = uid;
    })
    const url = this.router.url.split("?");
    const splitURL = url[0].split("/");
    // find current page name in the url and check if it is the same as the last page name in the url
    const lastIndex = this.narratorData?.urlPageName ? this.narratorData?.urlPageName : splitURL[splitURL.length - 1];
    if (
      (this.narratorData?.setting?.page_name == lastIndex || this.narratorData?.setting?.page_name == "checkout")
      && this.narratorData?.setting?.seen !== true
    ) {
      this.narratorShow = false;
    }
    // checking if there are more than one narrator data in the page
    if (this.narratorData?.content?.length > 1) {
      const length = this.narratorData?.content[this.narratorIndex]?.text.length;
      const divideBy = 23.3; //display next icon based on time value
      const calculateTime = 1000;
      let time: number = (length / divideBy) * calculateTime;
      time = Math.round(time);
      setTimeout(() => {
        this.nextButton = true;
      }, time);
      this.closeIconShow = false;
    } else {
      setTimeout(() => {
        // this method is used to detect word count of narrator text
        this.detectWordCount();
      }, this.setTimer2);
    }
    //Checking if the image is available
    if (
      this.narratorData?.content?.[0]?.image_url &&
      typeof this.narratorData?.content?.[0]?.image_url != "undefined"
    ) {
      //Set the time of the narrator tip to display the image
      setTimeout(() => {
        this.cardImage = true;
      }, this.setTimer3);
    }
    //Set the time of the narrator tip to display the text
    this.jackpotTipViewTimeoutId = setTimeout(() => {
      this.jackpotTipViewTimeoutId = null;
      if (this.isDestroyed) {
        return;
      }
      this.displayAvatar = true;
      this.typingCallback(this);
      if (this.isTipJackpotTrigger) {
        this.trackJackpotTriggerNarratorTipViewed();
      }
    }, this.setTimer2);
  }

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      const narratorTip = this.el.nativeElement.closest('.narrator-tip');
      const narratorId = this.narratorData?.narrator_id?.trim(); // Ensure it's not empty or whitespace
      if (
        narratorId === 'tip_discount_voucher_store' ||
        narratorId === 'tip_discount_voucher_product' ||
        narratorId === 'tip_bonus_credit'
      ) {
        this.isTipDiscountVoucherStore = true;
      }
      if (narratorId === 'tip_jackpot_trigger') {
        this.isTipJackpotTrigger = true;
        this.jackpotTriggerEntryPoint = this.resolveJackpotTriggerEntryPoint(this.router.url);
      }
      if (!narratorTip || !narratorId) return; // Prevent errors
      // Sanitize the class name to remove invalid characters
      const sanitizedClass = narratorId.replace(/[^a-zA-Z0-9_-]/g, '');
      if (sanitizedClass) {
        this.renderer.addClass(narratorTip, sanitizedClass);
      }
    });
  }

  /** Replaces `[profile_nickname]` in CMS narrator strings with the logged-in user's nickname. */
  private resolveNarratorPlaceholders(text: string | undefined): string {
    if (typeof text !== "string" || !text.includes("[profile_nickname]")) {
      return text ?? "";
    }
    return text.replace(/\[profile_nickname\]/g, this.profileNickname || "");
  }

  // This method is used to display the narrator tip
  public typingCallback(that) {
    if (that.narratorData?.content?.length > 0) {
      this.displayTypewriterText = this.resolveNarratorPlaceholders(
        that.narratorData?.content[that.narratorIndex]?.text
      );
    }
  }

  public setupJackpotTriggerNow(): void {
    const data = this.narratorData;
    const narratorID = data?.id ?? localStorage.getItem("narratorID");
    // Capture before dismiss/navigation — router.url will change after navigate.
    const entryPoint = this.jackpotTriggerEntryPoint;

    this.trackJackpotTriggerNarratorTipInteracted("cta_click", "Setup now");
    this.dismissNarratorTip();

    if (narratorID) {
      this.narratorStateUpdate(narratorID);
    }

    if (data?.action?.type === "nav" && data?.action?.details) {
      this.router.navigateByUrl(data.action.details).then((navigated) => {
        if (navigated) {
          this.trackJackpotTriggerActivationAreaViewed(entryPoint);
        }
      }).catch((error) => {
        this.authService.errorHandlerLogs(
          "[NarratorTips] setupJackpotTriggerNow action navigation error",
          error
        );
      });
      return;
    }

    if (this.isOnStorePage()) {
      this.scrollToJackpotTriggerSection();
      this.trackJackpotTriggerActivationAreaViewed(entryPoint);
      return;
    }

    this.router.navigate(["/mainTabs/tabs/store"], { fragment: "jackpot_trigger" }).then((navigated) => {
      if (navigated) {
        this.trackJackpotTriggerActivationAreaViewed(entryPoint);
      }
    }).catch((error) => {
      this.authService.errorHandlerLogs(
        "[NarratorTips] setupJackpotTriggerNow store navigation error",
        error
      );
    });
  }

  private dismissNarratorTip(): void {
    this.narratorData = [];
    this.notificationManagerService.setNarratorTipDismissedState(true);
    this.dialogRef.close();
  }

  private isOnStorePage(): boolean {
    return this.router.url.split("?")[0].includes("/mainTabs/tabs/store");
  }

  private scrollToJackpotTriggerSection(): void {
    const element = document.getElementById("jackpot_trigger");
    if (element) {
      element.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
    }
  }

  closeNarrator(avatar) {
    let narratorID: string | null = null;
    if (avatar) {
      narratorID = avatar?.id;
    } else {
      narratorID = localStorage.getItem("narratorID");
    }

    // Defensive: always close the dialog, even if we can't find the narrator ID
    if (!narratorID) {
      this.matDialog.closeAll();
      return;
    }

    this.narratorStateUpdate(narratorID);
      this.narratorData = [];
      this.matDialog.closeAll();
      const actionDetails = avatar?.action?.details;
      if (avatar?.action?.type === "nav" && actionDetails) {
        this.router.navigateByUrl(actionDetails)?.catch((error) => error);
      } else if (avatar?.action?.type === "script" && actionDetails) {
        this.router.navigateByUrl("/mainTabs/tabs/store");
        const element = document.getElementById("ct-nat-store");
        if (element) {
          element.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
        }
      }
      if (avatar?.setting?.destination) {
        const target = avatar?.setting?.destination;
        // Prefer current games tab (game-new / game / social). Hardcoding /game
        // sent users away from game-new after closing a tip with a destination.
        const currentUrl = this.router.url || "";
        const alreadyOnGamesTab =
          currentUrl.includes("/mainTabs/tabs/game-new") ||
          currentUrl.includes("/mainTabs/tabs/game") ||
          currentUrl.includes("/mainTabs/tabs/social");
        if (!alreadyOnGamesTab) {
          const stored = localStorage.getItem("game_path");
          const allowed = new Set(["game", "game-new", "social"]);
          const gamePath = allowed.has(stored ?? "") ? stored! : "game";
          this.router.navigateByUrl(`/mainTabs/tabs/${gamePath}`);
        }
        document.getElementById(target)
          ? document.getElementById(target).scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" })
          : "";
    }
  }

  // This method is used to display next narrator tip in the given array
  public nextNarratorTip(contentLength) {
    if (this.isTipJackpotTrigger) {
      this.trackJackpotTriggerNarratorTipInteracted("next", "Next");
    }
    // set close icon value false
    this.closeIconShow = false;
    // Checking if there is a next tip available
    if (this.narratorIndex < contentLength.length - 1) {
      this.narratorIndex = this.narratorIndex + 1;
      // Checking if there is a image available
      if (
        this.narratorData?.content[this.narratorIndex]?.image_url &&
        typeof this.narratorData?.content[this.narratorIndex]?.image_url !== "undefined"
      ) {
        this.cardImage = true;
      } else {
        this.cardImage = false;
      }
      this.displayTypewriterText = "";
      (document.querySelector(".type") as HTMLElement).style.animation = "none";
      const timeOut = 10;
      setTimeout(() => {
        (document.querySelector(".type") as HTMLElement).style.animation = "";
      }, timeOut);
      this.typingCallback(this);
      if (this.narratorIndex + 1 === contentLength?.length) {
        this.nextButton = false;
        setTimeout(() => {
          this.closeIconShow = true;
        }, this.setTimer)
      }
    }
  }

  // This method is used to update the narrator state
  public narratorStateUpdate(documentId: string) {
    this.notificationManagerService.setNarratorTipDismissedState(true);
    const path_id = "6bN0prM7tNp1cWRhFqlT";
    const doc_data = { setting: { seen: true } };
    const dv = { docId: documentId };
    const method = "update";

    return this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        this.authService.errorHandlerLogs("narratorStateUpdate error:", error);
      }
    });
  }

  // this method is used to detect word count of narrator text and display close icon after the typing end
  public detectWordCount(): void {
    setTimeout(() => {
      const textElement = this.narratorTipContent?.nativeElement;
      const textLength = textElement?.innerHTML.length;
      typingTime = textLength * setLimit; // adjust this value as needed
      setTimeout(() => {
        this.closeIconShow = true;
      }, typingTime + blinkCaretTime);
    });
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    if (this.jackpotTipViewTimeoutId !== null) {
      clearTimeout(this.jackpotTipViewTimeoutId);
      this.jackpotTipViewTimeoutId = null;
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  private resolveJackpotTriggerEntryPoint(url: string): "cancellation_flow" | "other" {
    return url.includes("TP1=downgrade") ? "cancellation_flow" : "other";
  }

  private getJackpotTriggerTrackingContext(): Data {
    return {
      page_name: "store",
      narrator_id: "tip_jackpot_trigger",
      entry_point: this.jackpotTriggerEntryPoint,
    };
  }

  private ensureMixpanelInitialized(): void {
    if (this.userId) {
      this.mixPanelService.init(this.userId);
    }
  }

  private trackJackpotTriggerNarratorTipViewed(): void {
    if (this.isDestroyed || this.jackpotTriggerTipViewTracked) {
      return;
    }
    this.jackpotTriggerTipViewTracked = true;
    this.ensureMixpanelInitialized();
    this.mixPanelService.syndicateCancellationMixpanel(
      "Store",
      "Jackpot Trigger narrator tip",
      "view",
      "Jackpot Trigger narrator tip viewed"
    );
    this.gtmSegment.trackEvent("Jackpot Trigger narrator tip viewed", this.getJackpotTriggerTrackingContext());
  }

  private trackJackpotTriggerNarratorTipInteracted(interactionType: string, buttonName: string): void {
    this.ensureMixpanelInitialized();
    this.mixPanelService.syndicateCancellationMixpanel(
      "Store",
      "Jackpot Trigger narrator tip",
      interactionType,
      buttonName
    );
    this.gtmSegment.trackEvent("Jackpot Trigger narrator tip interacted", {
      ...this.getJackpotTriggerTrackingContext(),
      interaction_type: interactionType,
      button_name: buttonName,
    });
  }

  private trackJackpotTriggerActivationAreaViewed(
    entryPoint: "cancellation_flow" | "other" = this.jackpotTriggerEntryPoint
  ): void {
    this.ensureMixpanelInitialized();
    this.mixPanelService.syndicateCancellationMixpanel(
      "Store",
      "Jackpot Trigger activation area",
      "view",
      "Jackpot Trigger activation area viewed"
    );
    this.gtmSegment.trackEvent("Jackpot Trigger activation area viewed", {
      page_name: "store",
      section_id: "jackpot_trigger",
      entry_point: entryPoint,
    });
  }
}
